import {CloudUpload} from '@mui/icons-material';
import {MenuItem, ListItemIcon} from '@mui/material';
import Typography from '@mui/material/Typography';

import useProjectCrudModal from '../../../../../hooks/dom/useProjectCrudModal';
import useProjects from '../../../../../hooks/providers/useProjects';
import useUpload from '../../../../../hooks/providers/useUpload';

const ProjectMenuImportDataButton = () => {
  const {selectedProject: project, CONNECTORS_HAVING_IMPORT_DATA_BUTTON} = useProjects();
  const {setProjectSelected, setIsUploadFilesModalOpen} = useUpload();
  const {openModal} = useProjectCrudModal({setModalOpen: setIsUploadFilesModalOpen, project});
  const shouldRender = CONNECTORS_HAVING_IMPORT_DATA_BUTTON.includes(project?.connector);

  const handleOpen = openModalFunction => {
    setProjectSelected(project);
    openModalFunction();
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <MenuItem onClick={() => handleOpen(openModal)}>
      <ListItemIcon>
        <CloudUpload fontSize="small" color="primary" />
      </ListItemIcon>
      <Typography variant="inherit">Importer les données</Typography>
    </MenuItem>
  );
};

export default ProjectMenuImportDataButton;
